import { useTranslation } from "react-i18next";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Modal } from "@mantine/core";

import { Doc } from "@customTypes/index";

import { StyledDocViewer } from "./FilePreviewModal.styled";

import "@cyntler/react-doc-viewer/dist/index.css";


export const FilePreviewModal = ({
  docs,
  opened,
  close,
  initialActiveDocumentIndex = 0,
}: {
  docs: Doc[];
  opened: boolean;
  close: () => void;
  initialActiveDocumentIndex?: number;
}) => {
  const { i18n } = useTranslation();
  // console.log(docs);

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      withCloseButton={false}
      size={"lg"}>
      <StyledDocViewer>
        <DocViewer
          //* NOTE: fileNames will be the URL of the file which contains the domain name. This will be stripped by splitting the fileName at "/files/" until further changes on the backend
          documents={docs}
          language={i18n.language.slice(0, 2) === "en" ? "en" : "fr"}
          // style={{ maxHeight: "50vh" }}
          initialActiveDocument={docs[initialActiveDocumentIndex]}
          //   onDocumentChange={handleDocumentChange}
          pluginRenderers={DocViewerRenderers}
          config={{
            pdfVerticalScrollByDefault: true,
            // header: { disableHeader: true },
            pdfZoom: { defaultZoom: 1.3, zoomJump: 0.2 },
          }}
        />
      </StyledDocViewer>
    </Modal>
  );
};
